import { User } from '../user/user'
import { Domain } from '../domain/domain'
import { Account } from '../index'

export const ActionName = {
    LoadedPage: 'loaded_page',
    PushedImprovement: 'pushed_improvement',
    StartedMsOAuthFlow: 'started_ms_oauth_flow',
    OpenedMsBetaModal: 'opened_ms_beta_modal',
    CreatedRSA: 'created_rsa',
    UpdatedRSA: 'updated_rsa',
    SetAdStatus: 'set_ad_status',
    PauseSpendWhenOverBudgetAction: 'pause_spend_when_over_budget_action',
} as const

export type ActionName = (typeof ActionName)[keyof typeof ActionName]
export type CombinedActionName<TExtraActionName extends string = never> =
    | ActionName
    | TExtraActionName

export interface TrackParams<TExtraActionName extends string = never> {
    user_id: User.ID
    domain_id?: Domain.ID
    account_id?: Account.ID
    metadata: any
    action_name: CombinedActionName<TExtraActionName>
    vueo_version?: string
    env?: string
}

export interface TrackParamsWithIp<
    TExtraActionName extends string = never,
> extends TrackParams<TExtraActionName> {
    ip_address: string
}
